/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { api } from "../../services/api";
import {
  PageContent,
  PageHeader,
  PageTitle,
  PageSubtitle,
  SearchActions,
  BtnAdd,
  AddressList,
  AddressItem,
  AddressIcon,
  AddressText,
  AddressName,
  AddressDetail,
  BtnDelete,
} from "./styled";
import { MdSearch, MdAdd, MdDeleteOutline, MdLocationOn } from "react-icons/md";
import { createBrowserHistory } from "history";
import Load from "../../components/Load";
import Menu from "../../components/Menu";
import { Autocomplete } from "devextreme-react/autocomplete";
import "devextreme/dist/css/dx.light.css";
import useToast from "../../hooks/useToast";

const mapboxToken =
  "pk.eyJ1IjoiY2hyaXN0aWFub2xpbm8iLCJhIjoiY2s5ZWhnY21zMDBmNDNscDRtNnplNnhqcCJ9.KYxz1mLRgnZdWur4i3k4IQ";

export default function Endereco() {
  const history = createBrowserHistory();
  const { showToast } = useToast();
  const [load, setload] = useState(false);
  const [busline, setBusline] = useState({});
  const [addressList, setAddressList] = useState(
    localStorage.getItem("addressList") &&
      JSON.parse(localStorage.getItem("addressList"))
  );
  const [address, setAddress] = useState(localStorage.getItem("address"));
  const [addressSearch, setAddressSearch] = useState(true);

  const [endereco, setEndereco] = useState("");
  const [enderecoL, setEnderecoL] = useState({});

  const ccid = localStorage.getItem("CoastCenterID");

  const SearchbyAddress = () => {
    setload(true);
    if (!addressList) return;
    let coords = addressList[0].coords;
    if (!coords) return;

    localStorage.setItem("addressFix", address);
    localStorage.setItem("addressListFix", JSON.stringify(addressList));

    setEndereco(localStorage.getItem("addressFix"));
    setEnderecoL(localStorage.getItem("addressListFix"));

    api
      .get(`/busline?cost_center_id=${ccid}&lat=${coords[1]}&lng=${coords[0]}`)
      .then((resp) => {
        const { data } = resp;

        setBusline(data && data.busline);
      })
      .catch((error) => {
        console.log(error.response);
        setBusline({});
      })
      .finally(function () {
        setload(false);
      });
  };

  const deletAdr = () => {
    localStorage.removeItem("addressFix");
    setEndereco("1jhdgs");
    localStorage.removeItem("addressListFix");
    setEnderecoL("");
  };

  const savedAddress = localStorage.getItem("addressFix");
  const hasSavedAddress = savedAddress && endereco !== "1jhdgs";

  useEffect(() => {
    if (!!localStorage.getItem("addressList")) SearchbyAddress();
  }, []);

  useEffect(() => {
    setAddressList(undefined);
    if (!address) return;
    let places = address.toString().split(" ").join("+");
    let url =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      places +
      ".json?access_token=" +
      mapboxToken;

    axios
      .get(url)
      .then((resp) => {
        const { data } = resp;
        if (!data) return;
        if (!data.features) return;

        let list = data.features.map((row) => {
          return {
            text: address,
            name: row.place_name,
            coords: row.center,
          };
        });
        setAddressSearch(list.length <= 0 ? true : false);
        setAddressList(list);
      })
      .catch((error) => {
        showToast(
          error?.message || "Erro ao buscar endereço",
          "error"
        );
        console.log(error);
      })
      .finally(function () {});
  }, [address]);

  return (
    <>
      {load ? <Load /> : null}
      <Menu title="Endereços" />
      <PageContent>
        <PageHeader>
          <PageTitle>Endereços salvos</PageTitle>
          <PageSubtitle>Gerencie seus endereços favoritos</PageSubtitle>
        </PageHeader>

        <SearchActions>
          <MdSearch size={20} className="search-icon" />
          <Autocomplete
            dataSource={addressList && addressList}
            value={address && address}
            valueExpr="name"
            searchExpr="text"
            onValueChanged={(e) => setAddress(e.value)}
            minSearchLength={3}
            showClearButton={true}
            deferRendering={false}
            placeholder="Buscar por endereço..."
            className="search-address"
          />
          {address && (
            <BtnAdd onClick={SearchbyAddress} aria-label="Adicionar endereço">
              <MdAdd size={22} />
            </BtnAdd>
          )}
        </SearchActions>

        <AddressList>
          {hasSavedAddress && (
            <AddressItem>
              <AddressIcon>
                <MdLocationOn />
              </AddressIcon>
              <AddressText>
                <AddressName>{savedAddress}</AddressName>
                <AddressDetail>Endereço salvo</AddressDetail>
              </AddressText>
              <BtnDelete
                onClick={deletAdr}
                aria-label="Remover endereço"
              >
                <MdDeleteOutline size={20} />
              </BtnDelete>
            </AddressItem>
          )}
        </AddressList>
      </PageContent>
    </>
  );
}
